import React from 'react';
export function ProfileDeleteLiner18() {
  return /*#__PURE__*/React.createElement("svg", {
    width: "18",
    height: "18",
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.8075 13.5675L11.6925 15.6825M13.8075 15.6825L11.6925 13.5675M8.99998 16.3575C7.63498 16.3575 6.27748 16.0125 5.24248 15.3225C3.42748 14.1075 3.42748 12.1275 5.24248 10.92C7.30498 9.54 10.6875 9.54 12.75 10.92M9.11965 8.1525C9.04465 8.145 8.95465 8.145 8.87215 8.1525C7.08715 8.0925 5.66965 6.63 5.66965 4.83C5.66965 2.9925 7.15465 1.5 8.99965 1.5C10.8372 1.5 12.3297 2.9925 12.3297 4.83C12.3222 6.63 10.9047 8.0925 9.11965 8.1525Z",
    stroke: "currentColor",
    strokeWidth: "1.5",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }));
}